import { render, staticRenderFns } from "./single-stock-futures.vue?vue&type=template&id=2eb7784e&scoped=true"
import script from "./single-stock-futures.vue?vue&type=script&lang=js"
export * from "./single-stock-futures.vue?vue&type=script&lang=js"
import style0 from "./single-stock-futures.vue?vue&type=style&index=0&id=2eb7784e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb7784e",
  null
  
)

/* custom blocks */
import block0 from "./locale/single-stock-futures-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fproducts%2Fsingle-stock-futures.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/single-stock-futures-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fproducts%2Fsingle-stock-futures.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default,VueGlideComponent: require('/vercel/path0/components/vue-glide-component.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default,CImage: require('/vercel/path0/components/ui/c-image.vue').default,PhoneNumber: require('/vercel/path0/components/micro/PhoneNumber.vue').default,EmailAddress: require('/vercel/path0/components/micro/EmailAddress.vue').default,WebAddress: require('/vercel/path0/components/micro/WebAddress.vue').default,CtaImage: require('/vercel/path0/components/ui/cta-image.vue').default,DownloadCard: require('/vercel/path0/components/DownloadCard.vue').default,FaqsAccordion: require('/vercel/path0/components/datablocks/FaqsAccordion.vue').default})
